import {useCallback, useEffect, useState} from 'react';

import {RESPONSE_STATUSES} from '@/src/app/constants/api';
import {LocationType, LocationTypes} from '@/src/hooks/useCountriesList';
import fetchStatesDictionary from '@/src/signUp/emailStep/utils/fetchStatesDictionary';
import fetchStatesDictionaryWithClinics from '@/src/signUp/emailStep/utils/fetchStatesDictionaryWithClinics';
import fetchStatesDictionaryWithVacancies from '@/src/signUp/emailStep/utils/fetchStatesDictionaryWithVacancies';

const METHODS = {
  [LocationTypes.ALL]: fetchStatesDictionary,
  [LocationTypes.WITH_VACANCY]: fetchStatesDictionaryWithVacancies,
  [LocationTypes.WITH_CLINICS]: fetchStatesDictionaryWithClinics,
  [LocationTypes.WITH_USERS]: fetchStatesDictionary,
};

const useStatesLists = (
  countryId: string | string[],
  statesType: LocationType = LocationTypes.ALL,
  clinicId = null
) => {
  const [statesList, setStatesList] = useState([]);

  useEffect(() => {
    getStates(countryId);
  }, [countryId]);

  const getStates = useCallback(
    async (countryId) => {
      if (!countryId) {
        return setStatesList([]);
      }

      const {responseBody, status} = await METHODS[statesType](
        countryId,
        clinicId
      );

      if (status === RESPONSE_STATUSES.SUCCESS) {
        setStatesList(responseBody.data);
      }
    },
    [statesList, statesType]
  );

  return {
    statesList,
  };
};

export default useStatesLists;
